import { useContext } from 'react';
import { ChatHintsContext, ChatHintsLoadingContext, ChatInitialMessageContext } from './context';
import { BasicSystemUserMessage } from './Message.System.Basic';
import { SystemUserPlaceholderMessage } from './Message.System.Placeholder';

export const InitialSystemMessage = () => {
  const hints = useContext(ChatHintsContext);
  const message = useContext(ChatInitialMessageContext);
  const loading = useContext(ChatHintsLoadingContext);

  if (loading) {
    return <SystemUserPlaceholderMessage />;
  }

  return (
    <BasicSystemUserMessage hints={hints}>
      {message}
    </BasicSystemUserMessage>
  );
};